import React from "react";
import { connect } from "react-redux";
import { FormSpy } from "react-final-form";
import { addSubmitForm } from "../../../ducks/app";
import diff from "object-diff";

import { bindActionCreators } from "redux";

const _ = require("lodash");
const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {};
  };
  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addSubmitForm
    },
    dispatch
  );

@connect(
  makeMapStateToProps,
  mapDispatchToProps
)
class FormStateToRedux extends React.Component {
  render() {
    return (
      <FormSpy
        onChange={state => {
          if (state.values && state.values.attributes) {
            let difference = diff(
              state.initialValues.attributes,
              state.values.attributes
            );
            if (Object.keys(difference).length > 0) {
              return this.props.addSubmitForm({
                id: state.initialValues.id,
                type: this.props.form,
                attributes: { ...difference }
              });
            }
          }
        }}
      />
    );
  }
}

export default FormStateToRedux;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/FormStateToRedux.js